import { cva } from '@/styled-system/css';

export const avatarIconRecipe = cva({
  base: {},
  variants: {
    tone: {
      'default': {
        color: 'Avatar.Icon.default',
      },
      'brand-hero': {
        color: 'icon.onHero.neutral',
      },
      'accent-1': {
        color: 'icon.onHero.neutral',
      },
      'accent-2': {
        color: 'icon.onHero.neutral',
      },
      'accent-3': {
        color: 'icon.onHero.neutral',
      },
      'accent-4': {
        color: 'icon.onHero.neutral',
      },
    },
    size: {
      xs: {
        width: 'Avatar.Icon.xs',
        height: 'Avatar.Icon.xs',
      },
      sm: {
        width: 'Avatar.Icon.sm',
        height: 'Avatar.Icon.sm',
      },
      md: {
        width: 'Avatar.Icon.md',
        height: 'Avatar.Icon.md',
      },
      lg: {
        width: 'Avatar.Icon.lg',
        height: 'Avatar.Icon.lg',
      },
      xl: {
        width: 'Avatar.Icon.xl',
        height: 'Avatar.Icon.xl',
      },
      xxl: {
        width: 'Avatar.Icon.xxl',
        height: 'Avatar.Icon.xxl',
      },
    },
  },
});
